(function(angular) {
    "use strict";
    let profiles = {}, selectedProfile;

    class ProfileModel {
        constructor($rootScope, $q, $log) {
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.$log = $log;
        }

        setProfiles(p) {
            profiles = {};
            for (let profile of p) {
                profiles[profile.profileId] = profile;
            }
        }

        getProfiles() {
            return profiles;
        }

        getSelectedProfile() {
            return selectedProfile;
        }

        selectProfile(profile, channels) {
            let id = '';
            if (profile) {
                id = typeof profile === "object" && profile.hasOwnProperty("profileId") ? profile.profileId : profile;
            }
            else {
                throw "profileModel: profile parameter must be a valid profile or profile Id";
            }

            if (profiles.hasOwnProperty(id)) {
                selectedProfile = profiles[id];
                profiles[id].channels = channels.map(c => { return c.channelId; });
            } else {
                throw "profileModel: profile does not exist";
            }
        }

        getChannelIdsForProfile(profileId) {
            return profiles[profileId].channels;
        }

        addChannelToCurrentProfile(channelId) {
            this.getSelectedProfile().channels.push(channelId);
        }

        removeChannelFromCurrentProfile(channelId) {
            delete this.getSelectedProfile().channels[channelId];
        }

        updateProfileName(name) {
            if(selectedProfile) {
                profiles[selectedProfile.profileId].name = name;
            }
        }
    }

    angular
        .module('webcomm')
        .service('profileModel', ['$rootScope', '$q', '$log', ProfileModel]);
})(angular);
